import { render } from "./Ranking.vue?vue&type=template&id=4a609aca&ts=true"
import script from "./Ranking.vue?vue&type=script&lang=ts"
export * from "./Ranking.vue?vue&type=script&lang=ts"

import "./Ranking.vue?vue&type=style&index=0&id=4a609aca&lang=scss"

import exportComponent from "E:\\Code\\hjp\\yijian-proxy-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__